// import React from "react";
// import Layout from "../components/Layout";
// import ProductCard from "../components/ProductCard";
// import styles from "./Atlantic.module.css";

// const tunaProducts = [
//   {
//     title: "Тунець цілий в олії\nVALMIS",
//     image: "/assets/products/tuna/valmis-whole-oil-150.jpg",
//     weight: "150 г | Ж/б банка",
//     description: "Фасовка: 24 шт | 150 ящ/палет",
//   },
//   {
//     title: "Тунець цілий у власному соку\nVALMIS",
//     image: "/assets/products/tuna/valmis-whole-brine-150.jpg",
//     weight: "150 г | Ж/б банка",
//     description: "Фасовка: 24 шт | 150 ящ/палет",
//   },
//   {
//     title: "Тунець салатний в олії\nVALMIS",
//     image: "/assets/products/tuna/valmis-salad-oil-150.jpg",
//     weight: "150 г | Ж/б банка",
//     description: "Фасовка: 24 шт | 150 ящ/палет",
//   },
//   {
//     title: "Тунець салатний у власному соку\nVALMIS",
//     image: "/assets/products/tuna/valmis-salad-brine-150.jpg",
//     weight: "150 г | Ж/б банка",
//     description: "Фасовка: 24 шт | 150 ящ/палет",
//   },

//   // --- TUNCOFF ---
//   {
//     title: "Тунець цілий в олії\nТУНЦOFF",
//     image: "/assets/products/tuna/tuncoff-whole-oil-150.jpg",
//     weight: "150 г | Ж/б банка",
//     description: "Фасовка: 24 шт | 150 ящ/палет",
//   },
//   {
//     title: "Тунець цілий у власному соку\nТУНЦOFF",
//     image: "/assets/products/tuna/tuncoff-whole-brine-150.jpg",
//     weight: "150 г | Ж/б банка",
//     description: "Фасовка: 24 шт | 150 ящ/палет",
//   },
//   {
//     title: "Тунець салатний в олії\nТУНЦOFF",
//     image: "/assets/products/tuna/tuncoff-salad-oil-150.jpg",
//     weight: "150 г | Ж/б банка",
//     description: "Фасовка: 24 шт | 150 ящ/палет",
//   },
//   {
//     title: "Тунець салатний у власному соку\nТУНЦOFF",
//     image: "/assets/products/tuna/tuncoff-salad-brine-150.jpg",
//     weight: "150 г | Ж/б банка",
//     description: "Фасовка: 24 шт | 150 ящ/палет",
//   },
// ];

// const Tuna = () => (
//   <Layout>
//     <h2 className={styles.heading}>Тунець</h2>
//     <div className={styles.grid}>
//       {tunaProducts.map((p, i) => <ProductCard key={i} {...p} />)}
//     </div>
//   </Layout>
// );

// export default Tuna;


import React from "react";
import Layout from "../components/Layout";
import ProductCard from "../components/ProductCard";
import styles from "./Atlantic.module.css";
import { useLanguage } from "../i18n/LanguageContext";

const Tuna = () => {
  const { t } = useLanguage();

  const tunaProducts = [
    {
      title: t("tuna.products.valmisWholeOil.title"),
      image: "/assets/products/tuna/valmis-whole-oil-150.jpg",
      weight: t("tuna.products.valmisWholeOil.weight"),
      description: t("tuna.products.valmisWholeOil.description"),
    },
    {
      title: t("tuna.products.valmisWholeBrine.title"),
      image: "/assets/products/tuna/valmis-whole-brine-150.jpg",
      weight: t("tuna.products.valmisWholeBrine.weight"),
      description: t("tuna.products.valmisWholeBrine.description"),
    },
    {
      title: t("tuna.products.valmisSaladOil.title"),
      image: "/assets/products/tuna/valmis-salad-oil-150.jpg",
      weight: t("tuna.products.valmisSaladOil.weight"),
      description: t("tuna.products.valmisSaladOil.description"),
    },
    {
      title: t("tuna.products.valmisSaladBrine.title"),
      image: "/assets/products/tuna/valmis-salad-brine-150.jpg",
      weight: t("tuna.products.valmisSaladBrine.weight"),
      description: t("tuna.products.valmisSaladBrine.description"),
    },

    {
      title: t("tuna.products.tuncoffWholeOil.title"),
      image: "/assets/products/tuna/tuncoff-whole-oil-150.jpg",
      weight: t("tuna.products.tuncoffWholeOil.weight"),
      description: t("tuna.products.tuncoffWholeOil.description"),
    },
    {
      title: t("tuna.products.tuncoffWholeBrine.title"),
      image: "/assets/products/tuna/tuncoff-whole-brine-150.jpg",
      weight: t("tuna.products.tuncoffWholeBrine.weight"),
      description: t("tuna.products.tuncoffWholeBrine.description"),
    },
    {
      title: t("tuna.products.tuncoffSaladOil.title"),
      image: "/assets/products/tuna/tuncoff-salad-oil-150.jpg",
      weight: t("tuna.products.tuncoffSaladOil.weight"),
      description: t("tuna.products.tuncoffSaladOil.description"),
    },
    {
      title: t("tuna.products.tuncoffSaladBrine.title"),
      image: "/assets/products/tuna/tuncoff-salad-brine-150.jpg",
      weight: t("tuna.products.tuncoffSaladBrine.weight"),
      description: t("tuna.products.tuncoffSaladBrine.description"),
    },
  ];

  return (
    <Layout>
      <h2 className={styles.heading}>{t("tuna.title")}</h2>

      <div className={styles.grid}>
        {tunaProducts.map((p, i) => (
          <ProductCard key={i} {...p} />
        ))}
      </div>
    </Layout>
  );
};

export default Tuna;
